module.exports = __webpack_public_path__ + "static/img/invest-make2.0fe1d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-make2.jpg
// module id = Semz
// module chunks = 0